<template>
  <div class="email-send-button-wrapper"
       :class="wrapperClass"
       v-tooltip.top="tooltipOptions">
    <!-- ICON VARIANT -->
    <Button v-if="variant === 'icon'"
            :disabled="emailSendDisabled"
            class="p-button-outlined p-button-secondary p-button-sm p-d-flex p-ai-center p-jc-center"
            :class="{ 'disabled-btn': isDisabled || disabled, 'p-button-sm': isSmall }"
            style="width: 36px;"
            @click="handleClick">
      <i class="ti-email"/>
    </Button>

    <!-- TEXT VARIANT -->
    <Button v-else
            :disabled="emailSendDisabled"
            class="p-button-text"
            :class="{ 'disabled-btn': isDisabled || disabled, 'p-button-sm': isSmall }"
            icon="ti-email"
            :label="$t(label)"
            @click="handleClick"/>
  </div>
</template>

<script>
import constants from "@/constants";
import billingRestrictionsMixin from '@/mixins/billingRestrictionsMixin'

export default {
  name: 'EmailSendButton',
  mixins: [billingRestrictionsMixin],
  emits: ['create-email'],
  props: {
    item: {
      type: Object,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isSmall: {
      type: Boolean,
      default: false
    },

    // recipientType: { type: String, default: 'invoice' }, // 'invoice' | 'estimate'

    recipientType: {
      type: String,
      default: 'invoice',
      validator: v => ['invoice', 'estimate'].includes(v),
    },

    // variant: { type: String, default: 'icon' }, // 'icon' | 'text'
    variant: {
      type: String,
      default: 'icon',
      validator: v => ['icon', 'text'].includes(v),
    },

    label: { type: String, default: 'Send' },
    wrapperClass: { type: [String, Array, Object], default: '' },

    tooltipSendKey: { type: String, default: 'Send' },
    // tooltipNoCustomerEmailKey: { type: String, default: 'customerEmailNotSetMsg' },
    tooltipNoSenderAccountKey: { type: String, default: 'userEmailAccountNotSetMsg' },
    // tooltipNoCustomerKey: { type: String, default: 'customerNotSelectedMsg' },
  },

  methods: {
    handleClick() {
      if (this.emailSendDisabled) return

      this.$emit('create-email', {
        item: this.item,
        customerEmail: this.customerEmail,
      })
    },
  },
  computed: {
    emailSendDisabled() {
      return (
          this.isDisabled ||
          this.disabled ||
          this.billingActionIsRestricted()
      )
    },

    // tooltipOptions() {
    //   const text = this.tooltip
    //   return {
    //     value: text || '',
    //     disabled: !text,
    //   }
    // },
    tooltipOptions() {
      return this.billingActionTooltipOptions(false, this.tooltip)
    },

    customerEmail() {
      const customer = this.item?.customer
      const contactPerson = this.item?.contactPerson

      let email = null


      if (this.recipientType === 'estimate') {
        if (customer && +customer.type === constants.userTypes.legal_entity) {
          email = contactPerson?.email ?? customer?.email ?? null
        } else {
          email = customer?.email ?? contactPerson?.email ?? null
        }
      } else {
        email = customer?.email ?? contactPerson?.email ?? null
      }

      const normalized = (email ?? '').trim()
      return normalized.length ? normalized : null
    },

    senderLoaded() {
      return !!this.$store.getters.userEmailAccountsLoaded
    },

    senderHasAccount() {
      if (!this.senderLoaded) return null
      return !!this.$store.getters.userHasEmailAccount
    },

    disabledReason() {
      if (this.senderHasAccount === false) return 'no_sender_account'
      return null
    },

    isDisabled() {
      return this.disabledReason !== null
    },

    tooltip() {
      const r = this.disabledReason
      if (r === 'no_sender_account') return this.$t(this.tooltipNoSenderAccountKey)

      return this.variant === 'icon' ? this.$t(this.tooltipSendKey) : null
    },
  },
}
</script>
<style scoped>
.email-send-button-wrapper {
  display: inline-flex;
  width: fit-content;
}
</style>
